// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"436":"910ddf3e","506":"910ddf3e"}[chunkId] + ".chunk.css";
};